import theme from './theme.red';
export default {
  "uniqueId": "imp1",
  "appName": "DM",
  "appColor": theme.primaryColor,
  "inboxType": "alert",
  "important": true,
  "createdAt": "2019-06-02T06:48:00",
  "updatedAt": "2019-06-11T06:48:00",
  "messages": [{
    "uniqueId": 1,
    "status": "publish",
    "date": "2018-10-03T06:48:00",
    "author": {
      "name": "KulturIt",
      "email": "ivar.es@online.no"
    },
    "subject": "Planlagt vedlikehold",
    "message": "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Curabitur blandit tempus porttitor."
  }]
};